import type { Dictionary } from '../types'

export const tr: Dictionary = {
  products: {
    title: 'Ürün Yönetimi',
    new: 'Yeni Ürün',
    total: 'Toplam {count} ürün',
    searchPlaceholder: 'Ad veya SKU',
    loadFailed: 'Ürün listesi alınamadı. Lütfen tekrar deneyin.',
    translationTitle: 'Ürün çevirileri',
    translationDesc: 'JSON kapsamı mevcut filtre + sayfadır. Uzun açıklamalar için alan setini seçin.',
    fieldName: 'Ürün adı',
    fieldNameShort: 'Ad + kısa açıklama',
    fieldFull: 'Ad + kısa + uzun açıklama',
    fieldBadges: 'Rozetler / bilgi',
    scopePage: 'Sayfa {page}',
    scopeSearch: 'arama: "{q}"',
    scopeCategory: 'kategori #{id}',
    scopeCount: '{count} ürün',
    tableProduct: 'Ürün',
    tableSku: 'SKU',
    tableType: 'Tür',
    tablePrice: 'Fiyat',
    tableUpdated: 'Güncelleme',
    toggleActive: 'Ürün aktif edildi.',
    toggleInactive: 'Ürün pasife alındı.',
    statusUpdateFailed: 'Durum güncellenemedi',
    nameEmpty: 'Ürün adı boş olamaz.',
    categoryRequired: 'Kategori seçilmeli.',
    typeRequired: 'Ürün türü seçilmeli.',
    bundleTitle: 'Fiyat tarifesi',
    bundleHint: 'Bu ürünün satış fiyatı, seçtiğiniz ana ürünlerin aynı pazaryerindeki fiyatından toplanır. E-pin ise sipariş, ana ürünlerin kodlarından ayrı ayrı teslim edilir. Top-up hesaba yüklenir, kod ayrılmaz.',
    bundleSearch: 'Ana ürün ara',
    bundleAdd: 'Ekle',
    bundleEmpty: 'Tarife yok. Bu ürün kendi fiyatıyla satılır.',
    bundleQty: 'Adet',
    bundleAuto: 'Fiyat otomatik',
    bundleAutoHint: 'Açıksa ana ürün fiyatı değişince bu ürünün ilan fiyatı yeniden yazılır. Kapatırsanız veya pazaryeri fiyatını elle değiştirirseniz kilitlenir.',
    bundleSave: 'Tarifeyi kaydet',
    bundleSaved: 'Tarife kaydedildi.',
    bundleSaveFailed: 'Tarife kaydedilemedi.',
    bundleCalculated: 'Hesaplanan',
    bundleCurrent: 'İlandaki fiyat',
    rowSaved: 'Satır kaydedildi.',
    rowsSaved: '{count} satır kaydedildi.',
    rowsPartial: '{ok} satır kaydedildi, {failed} satır başarısız.',
    rowsEditing: '{count} satır düzenleniyor',
    editNew: 'Yeni ürün',
    editTitle: 'Ürün düzenle',
    backToList: 'Ürün listesine dön',
    nameCard: 'Ürün adı',
    nameCardSubtitle: 'Mağazada görünen başlık',
    imageCard: 'Ürün görseli',
    imageCardSubtitle: 'Kapak ve banner',
    optionsCard: 'Ürün seçenekleri',
    optionsCardSubtitle: 'Durum ve kategori',
    categoryTreeCard: 'Kategori ağacı',
    categoryTreeSubtitle: 'Seçili kategori ve hiyerarşi',
    parentLabel: 'Üst:',
    childCategories: 'Alt kategoriler',
    editCategoryLink: 'Kategoriyi düzenle →',
    detailsCard: 'Ürün detayları',
    detailsSubtitle: 'Açıklama, SEO, yaş ve envanter (görseller soldaki kartta)',
    tabDescriptionSettings: 'Açıklama ve Ayarlar',
    tabInventory: 'Varyant & stok',
    tabMarketplace: 'Mağaza fiyatları',
    categorySettingsHint: 'Yaş etiketleri, platform, bölge, Steam eşleşmesi ve gerekli alanlar kategori üzerinden yönetilir.',
    categorySettingsLink: 'Kategori ayarlarına git',
    noCategoryHint: 'Yaş, platform, bölge ve gerekli alanlar için önce bir kategori seçin; ardından kategori formundan yönetebilirsiniz.',
    sectionDescription: 'Açıklama',
    infoLabelText: 'Bilgi etiketi metni (Türkçe)',
    infoLabelOther: 'Bilgi etiketi (diğer diller)',
    labelColor: 'Etiket rengi',
    badgesHint: 'Ürün kartı rozetleri: kampanya görsel üzerinde; kupon ve taksit avantaj satırında görünür.',
    campaignBadge: 'Kampanya rozeti',
    campaignBadgeHint: 'Örn. Yaz Kampanyası — ürün görseli üzerinde',
    couponBadge: 'Kupon avantajı',
    couponBadgeHint: 'Örn. Ek 10 TL Kupon',
    installmentBadge: 'Taksit avantajı',
    installmentBadgeHint: 'Örn. Peşin fiyatına 9 x 1.250 TL',
    shortDescription: 'Kısa açıklama (Türkçe)',
    shortDescriptionOther: 'Kısa açıklama (diğer diller)',
    longDescription: 'Uzun açıklama (Türkçe)',
    longDescriptionOther: 'Uzun açıklama (diğer diller)',
    longDescriptionPlaceholder: 'Ürün açıklamasını düzenleyin…',
    sectionSettings: 'Ayarlar',
    billingSection: 'Fatura',
    billingName: 'Faturada görünecek ürün adı',
    billingNameHint: 'Boşsa mağaza adı kullanılır.',
    productType: 'Ürün türü',
    skuOptional: 'SKU (isteğe bağlı)',
    marketPrice: 'Market fiyatı',
    publishDate: 'Yayın tarihi',
    validationError: 'Ad, kategori ve ürün türü zorunludur.',
    saveFailedMessage: 'Kayıt başarısız. Alanları kontrol edin.',
    createSuccess: 'Ürün oluşturuldu.',
    updateSuccess: 'Ürün güncellendi.',
    loadFailedForm: 'Ürün yüklenemedi.',
    saving: 'Kaydediliyor…',
    noProductTypes: 'Tenant veritabanında aktif ürün türü yok. Ürün oluşturmak için önce product_types tablosuna kayıt ekleyin.',
    inventoryAfterSave: 'Varyant ve stok satırlarını ürünü kaydettikten sonra "Varyant & stok" sekmesinden yönetebilirsiniz.',
    imagesAfterSave: 'Ürünü kaydettikten sonra sol karttan kapak, banner ve galeri görsellerini yönetebilirsiniz.',
    colorNone: 'Yok',
    colorRed: 'Kırmızı',
    colorGreen: 'Yeşil',
    colorBlue: 'Mavi',
    colorYellow: 'Sarı',
    published: 'Yayında',
    seo: {
      urlTitle: 'SEO URL',
      urlHint: 'küçük harf, rakam ve tire',
      slugLabel: 'URL slug',
      slugHintNew: 'Örn. ornek-urun (küçük harf, rakam, tire)',
      slugHintExisting: 'Mevcut: {slug}',
      metaTitleCard: 'Meta başlık',
      metaTitleHint: '~60 karakter önerilir',
      metaTitleLabel: 'Meta başlık',
      metaDescCard: 'Meta açıklama',
      metaDescHint: '~160 karakter; anahtar kelimeleri doğal kullanın',
      metaDescLabel: 'Meta açıklama',
      keywordsCard: 'Meta anahtar kelimeler',
      keywordsHint: 'virgülle ayırın',
      keywordsLabel: 'Anahtar kelimeler',
      keywordsFieldHint: 'Virgülle ayırın.',
      extraCard: 'Ek SEO ayarları',
      extraHint: '(GA ve paylaşım görseli; görsel için 1200×630 önerilir)',
      ogImageLabel: 'Paylaşım görseli URL',
      ogImageHint: '1200×630 önerilir. Dosya yükleme yakında.',
      geoCard: 'Sayfa altı SEO & GEO',
      geoHint: '(vitrin ürün detayında gösterilir)',
      previewCard: 'Arama motoru önizlemesi',
      multilingualSoon: 'Çoklu dil içerikleri yakında',
      pageTitle: 'Sayfa başlığı',
      pageDesc: 'Arama sonuçlarında görünecek açıklama metni burada yer alır.',
      exampleSlug: 'ornek-urun',
      slugPlaceholder: 'ornek-urun',
      previewTitleFallback: 'Sayfa başlığı',
      previewDescFallback: 'Arama sonuçlarında görünecek açıklama metni burada yer alır.',
      seoUrl: 'SEO URL',
      seoUrlHint: 'küçük harf, rakam ve tire',
      urlSlug: 'URL slug',
      slugNewHint: 'Örn. ornek-urun (küçük harf, rakam, tire)',
      slugExistingHint: 'Mevcut: {slug}',
      metaTitle: 'Meta başlık',
      metaDesc: 'Meta açıklama',
      metaKeywords: 'Meta anahtar kelimeler',
      metaKeywordsHint: 'virgülle ayırın',
      metaKeywordsInputHint: 'Virgülle ayırın.',
      extraSettings: 'Ek SEO ayarları',
      extraSettingsHint: 'GA ve paylaşım görseli; görsel için 1200×630 önerilir',
      gaId: 'Google Analytics ID',
      gaIdHint: 'G-XXXXXXXXXX veya UA-XXXXXXX-X',
      ogImageUrl: 'Paylaşım görseli URL',
      seoGeoTitle: 'Sayfa altı SEO & GEO',
      seoGeoHint: 'vitrin ürün detayında gösterilir',
      previewTitle: 'Arama motoru önizlemesi',
      previewHint: 'Google sonuç taklidi',
    },
    platforms: {
      loading: 'Platformlar yükleniyor…',
      error: 'Platform listesi alınamadı. Ağ bağlantınızı kontrol edin.',
      title: 'Platformlar',
      system: 'Sistem',
      desc: 'Kategorideki tüm ürünler için geçerli platformları işaretleyin. Yeni platform tanımlamak için Kategori Platformları menüsünü kullanın.',
      empty: 'Tenant veritabanında aktif platform kaydı yok. Önce Platformlar menüsünden ekleyin.',
    },
    regions: {
      loading: 'Bölgeler yükleniyor…',
      error: 'Ülke listesi alınamadı.',
      selectedTitle: 'Seçilen ülkeler',
      selectedBadge: 'Aktif · {count}',
      searchSelected: 'Seçilen ülkelerde ara…',
      noSelected: 'Henüz ülke seçilmedi. Aşağıdan ekleyin.',
      allTitle: 'Tüm ülkeler',
      searchAll: 'Tüm ülkelerde ara…',
      emptyTenant: 'Tenant bölge tablosu boş.',
      emptyFilter: 'Aramanızla eşleşen veya eklenebilir ülke kalmadı.',
      available: 'Mevcut',
    },
    age: {
      hint: 'USK, ESRB ve PEGI etiketlerini ürün kartında gösterim için işaretleyin. Birden fazla seçim mimari olarak mümkün; vitrinde yalnızca ilk uygun gösterim kullanılabilir.',
      germany: 'Almanya',
      america: 'Amerika',
      europe: 'Avrupa',
    },
    req: {
      saveFirst: 'Önce ürünü kaydedin; ardından satış ve "bize sat" için gerekli alanları buradan tanımlayabilirsiniz.',
      productTitle: 'Ürün gerekli alanları',
      productSubtitle: 'Satışta müşteriden istenecek ek bilgiler',
      sellUsTitle: 'Ürün bize sat gerekli alanları',
      sellUsSubtitle: 'Pazar yerine / bize satışta istenecek bilgiler',
      active: 'Aktif',
      passive: 'Pasif',
      noLabel: 'Hayır',
      noDesc: 'Ekstra alan istenmeyecek',
      yesLabel: 'Evet',
      yesDesc: 'Müşteriden ek bilgi alınacak',
      fieldList: 'Alan listesi',
      addField: 'Alan ekle',
      fieldNumber: 'Alan #{num}',
      fieldType: 'Alan türü',
      typeInfo: 'Bilgi mesajı',
      typeText: 'Metin girişi',
      typeOption: 'Seçenekli',
      fieldTitle: 'Başlık',
      fieldTitleHint: 'Örn. Steam kullanıcı adı',
      fieldInfoText: 'Bilgi metni',
      fieldPlaceholder: 'Placeholder',
      fieldDefault: 'Varsayılan',
      fieldMinChar: 'Min karakter',
      fieldMaxChar: 'Max karakter',
      fieldOptions: 'Seçenekler (satır başına bir)',
      fieldImageLabel: 'Bilgi görseli',
      fieldImageOptional: '(isteğe bağlı)',
      fieldImageDesc: 'Müşteri bilgi modalında gösterilecek görsel. JPEG, PNG veya WebP — en fazla 5 MB.',
      fieldImageSaveFirst: 'Yeni alan için önce ürünü kaydedin; ardından bilgi görseli yükleyebilirsiniz.',
      fieldImageDescMeta: 'Görsel açıklaması',
      fieldImageUploadMsg: 'Görsel yüklemek için önce ürünü kaydedin.',
      fieldImageUploaded: 'Bilgi görseli yüklendi.',
      fieldImageUploadFailed: 'Görsel yüklenemedi.',
      fieldImageRemoveConfirm: 'Bilgi görselini kaldırmak istiyor musunuz?',
      fieldImageRemoved: 'Görsel kaldırıldı.',
      fieldImageRemoveFailed: 'Görsel kaldırılamadı.',
      fieldImageNoPreview: 'Önizleme yok',
      fieldImageChangeBtn: 'Görseli değiştir',
      fieldImageUploadBtn: 'Görsel yükle',
    },
    reqFields: {
      no: 'Hayır',
      noHint: 'Ekstra alan istenmeyecek',
      yes: 'Evet',
      yesHint: 'Müşteriden ek bilgi alınacak',
      fieldList: 'Alan listesi',
      addField: 'Alan ekle',
      fieldNumber: 'Alan #{n}',
      fieldType: 'Alan türü',
      typeInfo: 'Bilgi mesajı',
      typeText: 'Metin girişi',
      typeOption: 'Seçenekli',
      fieldTitle: 'Başlık',
      fieldTitleHint: 'Örn. Steam kullanıcı adı',
      infoText: 'Bilgi metni',
      placeholder: 'Placeholder',
      defaultValue: 'Varsayılan',
      minChar: 'Min karakter',
      maxChar: 'Max karakter',
      options: 'Seçenekler (satır başına bir)',
      imageCaption: 'Görsel açıklaması',
      saveFirst: 'Önce ürünü kaydedin; ardından satış ve "bize sat" için gerekli alanları buradan tanımlayabilirsiniz.',
      productTitle: 'Ürün gerekli alanları',
      productSubtitle: 'Satışta müşteriden istenecek ek bilgiler',
      sellUsTitle: 'Ürün bize sat gerekli alanları',
      sellUsSubtitle: 'Pazar yerine / bize satışta istenecek bilgiler',
    },
    marketplace: {
      title: 'Mağaza fiyatları',
      desc: 'Bu ürünün mağazalardaki satış, alış ve bayi fiyatlarını yönetin.',
      addBtn: 'Mağazaya ekle',
      store: 'Mağaza',
      sale: 'Satış',
      buy: 'Alış',
      dealer: 'Bayi',
      virtualStock: 'Sanal stok',
      empty: 'Bu ürün henüz bir mağazaya eklenmemiş.',
      deleteConfirm: 'Bu mağaza fiyat kaydını silmek istediğinize emin misiniz?',
      deleteSuccess: 'Mağaza fiyatı silindi.',
      deleteFailed: 'Silinemedi',
    },
    variants: {
      title: 'Varyantlar',
      addBtn: 'Varyant ekle',
      empty: 'Henüz varyant yok.',
      editTitle: 'Varyant düzenle',
      addTitle: 'Varyant ekle',
      saved: 'Varyant güncellendi.',
      added: 'Varyant eklendi.',
      deleted: 'Varyant silindi.',
      nameRequired: 'Varyant adı zorunludur.',
      nameLabel: 'Varyant adı *',
      description: 'Açıklama',
      order: 'Sıra',
      activeLabel: 'Aktif',
      deleteConfirm: 'Bu varyantı silmek istediğinize emin misiniz?',
      actionFailed: 'İşlem başarısız.',
      deleteFailed: 'Silinemedi.',
    },
    stocks: {
      title: 'Stok satırları',
      allList: 'Tüm stok listesi',
      addBtn: 'Stok ekle',
      empty: 'Henüz stok satırı yok.',
      noCurrency: 'Para birimi tanımı yok. Tenant veritabanında currencies kaydı ekleyin.',
      editTitle: 'Stok düzenle',
      addTitle: 'Stok ekle',
      saved: 'Stok güncellendi.',
      added: 'Stok satırı eklendi.',
      deleted: 'Stok satırı silindi.',
      currencyRequired: 'Para birimi seçin.',
      codeRequired: 'Ürün kodu zorunludur.',
      actionFailed: 'İşlem başarısız.',
      deleteFailed: 'Silinemedi.',
      productLabel: 'Ürün: /{slug}',
      codeLabel: 'Ürün kodu *',
      barcode: 'Barkod',
      currencyLabel: 'Para birimi *',
      variantLabel: 'Varyant (isteğe bağlı)',
      variantNone: 'Yok (ana ürün)',
      salePrice: 'Satış fiyatı',
      cost: 'Maliyet',
      marketPrice: 'Piyasa fiyatı',
      statusOnSale: 'Satışta',
      statusSoldOut: 'Tükendi',
      activeLabel: 'Aktif',
      salePriceLabel: 'Satış: {price}',
      deleteConfirm: 'Bu stok satırını silmek istediğinize emin misiniz?',
    },
    images: {
      coverTitle: 'Kapak',
      coverDesc: 'Liste ve ürün kartında görünen ana görsel.',
      coverBadge: '1:1 önerilir',
      bannerTitle: 'Banner',
      bannerDesc: 'Üst şerit / vitrin alanı için isteğe bağlı.',
      bannerBadge: '1440×600px · peyzaj',
      galleryTitle: 'Galeri',
      galleryDesc: 'Ek ürün fotoğrafları. Silmedikçe kayıtlar kalır; kapak veya banner için yukarıdaki küçük önizlemelere tıklayabilirsiniz.',
      uploadRulesTitle: 'Yükleme kuralları',
      uploadRule1: 'Sadece görsel (JPEG, PNG, WebP, GIF); dosya başına en fazla 5 MB.',
      uploadRule2: 'Aşağıdaki önizlemeler 1:1 kutuda; mümkünse kare kaynak kullanın — liste ve kartlarda daha düzgün görünür.',
      uploadRule3: 'Plan medya kotası (media_library) aşılırsa yükleme reddedilir.',
      coverUpdated: 'Kapak güncellendi.',
      bannerUpdated: 'Banner güncellendi.',
      updateFailed: 'Güncelleme başarısız.',
      coverUploaded: 'Kapak yüklendi.',
      bannerUploaded: 'Banner yüklendi.',
      uploadFailed: 'Yükleme başarısız. Kotayı veya dosyayı kontrol edin.',
      bannerFailed: 'Banner yüklenemedi.',
      galleryAdded: 'Galeriye eklendi.',
      galleryDeleted: 'Görsel silindi.',
      coverRemoved: 'Kapak kaldırıldı.',
      bannerRemoved: 'Banner kaldırıldı.',
      noImage: 'Henüz yok',
      uploading: 'Yükleniyor…',
      uploadBtn: 'Yükle',
      removeBtn: 'Kaldır',
      coverRemoveConfirm: 'Kapak görselini kaldır?',
      bannerRemoveConfirm: 'Banner görselini kaldır?',
      galleryRemoveConfirm: 'Bu görseli galeriden silmek istiyor musunuz?',
      pickFromGallery: 'Galeriden ata',
      selectImage: 'Bu görseli seç',
      imageOnly: 'Yalnızca görsel dosyaları yüklenebilir (JPEG, PNG, WebP, GIF vb.).',
      maxSize: 'Dosya boyutu en fazla 5 MB olabilir (sunucu kuralı).',
    },
  },

  categories: {
    title: 'Kategoriler',
    new: 'Yeni kategori',
    total: 'Toplam {count} kayıt',
    searchPlaceholder: 'Kategori adı',
    loadFailed: 'Liste alınamadı.',
    translationTitle: 'Kategori çevirileri',
    translationDesc: 'JSON kapsamı mevcut arama + sayfadır. Uzun HTML alanlar için ayrı set seçin.',
    fieldName: 'Kategori adı',
    fieldNameDesc: 'Ad + açıklama',
    fieldGuides: 'Nasıl kullanılır + sistem gereksinimleri',
    fieldFull: 'Tüm metin alanları',
    scopePage: 'Sayfa {page}',
    scopeSearch: 'arama: "{q}"',
    scopeCount: '{count} kategori',
    tableCategory: 'Kategori',
    tableParent: 'Üst',
    tableType: 'Tür',
    tableBrand: 'Marka',
    tableVat: 'KDV %',
    toggleActive: 'Kategori aktif edildi.',
    toggleInactive: 'Kategori pasife alındı.',
    statusUpdateFailed: 'Durum güncellenemedi',
    nameEmpty: 'Kategori adı boş olamaz.',
    selfParent: 'Kategori kendi üst kategorisi olamaz.',
    rowSaved: 'Satır kaydedildi.',
    rowsSaved: '{count} satır kaydedildi.',
    rowsPartial: '{ok} satır kaydedildi, {failed} satır başarısız.',
    rowsEditing: '{count} satır düzenleniyor',
    editNew: 'Yeni kategori',
    editTitle: 'Kategori düzenle',
    backToList: 'Listeye dön',
    copyTitle: 'Kategoriyi kopyala',
    deleteTitle: 'Kategoriyi sil',
    copyLabel: 'Kopyala',
    saving: 'Kaydediliyor…',
    saveChanges: 'Değişiklikleri Kaydet',
    nameCard: 'Kategori Adı',
    nameCardSubtitle: 'Kategori için benzersiz bir isim belirleyin',
    slugOptional: 'Slug (isteğe bağlı)',
    slugHint: 'Boş bırakılırsa addan üretilir',
    slugReadonlyLabel: "Sayfa URL'si",
    slugReadonlyPrefix: '/kategori/',
    imagesCard: 'Kategori görselleri',
    imagesCardSubtitle: 'Kapak ve banner (ImageMan)',
    imagesAfterSave: 'Kategoriyi kaydettikten sonra kapak ve banner yükleyebilirsiniz.',
    optionsCard: 'Kategori Seçenekleri',
    optionsCardSubtitle: 'Kategori durumu ve hiyerarşi ayarları',
    parentCategoryLabel: 'Üst Kategori',
    parentHint: 'Alt kategori oluşturmak için üst kategori seçin',
    parentNone: 'Ana Kategori (Üst kategori yok)',
    statusCard: 'Kategori Durumu',
    statusVisible: 'Aktif kategoriler kullanıcılara görünür',
    treeCard: 'Kategori Ağacı',
    treeSubtitle: 'Kategori hiyerarşi yapısı',
    treeEmpty: 'Henüz kategori bulunmuyor.',
    treeCurrent: 'Mevcut',
    treeRoot: 'Ana',
    detailsCard: 'Kategori detayları',
    detailsSubtitle: 'Ayarlar, içerik, SEO ve galeri (ad ve görseller soldaki kartta)',
    tabSettings: 'Ayarlar',
    tabDescription: 'Açıklama',
    tabSeo: 'Meta SEO',
    tabGallery: 'Galeri',
    tabRequiredFields: 'Gerekli Alanlar',
    tabRequirements: 'Gereksinimler',
    tabHowToUse: 'Kullanım',
    tabAge: 'Yaş',
    tabPlatform: 'Platform',
    tabRegion: 'Bölge',
    settingsTitle: 'Kategori Ayarları',
    settingsConfig: 'Yapılandırma',
    categoryType: 'Kategori Türü',
    brand: 'Marka / Yapımcı',
    pageView: 'Sayfa Görünümü',
    pageViewList: 'Liste Görünümü',
    pageViewGrid: 'Kart Görünümü',
    pageViewDetail: 'Detaylı Arama',
    orderLabel: 'Sıra',
    taxLabel: 'Vergi (%)',
    taxHint: 'Örn: 20',
    releaseYear: 'Çıkış Tarihi',
    releaseYearHint: 'Örn: 2024',
    languageField: 'Dil',
    languageHint: 'Örn: Türkçe',
    regionField: 'Bölge',
    regionHint: 'Örn: TR',
    website: 'Web Sitesi',
    billingSection: 'Faturalandırma',
    billingQuestion: 'Bu kategori için fatura kesilsin mi?',
    notSelected: 'Seçilmedi',
    descriptionTitle: 'Kategori Açıklaması',
    descriptionContent: 'İçerik',
    descriptionLabel: 'Açıklama (Türkçe)',
    descriptionPlaceholder: 'Kategori hakkında detaylı bilgi…',
    descriptionHint: 'Kategori hakkında detaylı bilgi',
    descriptionOther: 'Açıklama (diğer diller)',
    descTr: 'Açıklama (Türkçe)',
    descPlaceholder: 'Kategori hakkında detaylı bilgi…',
    descHint: 'Kategori hakkında detaylı bilgi',
    descOtherLangs: 'Açıklama (diğer diller)',
    seoMetaSection: 'Meta Etiketleri',
    seoMetaTitle: 'Meta Etiketleri',
    seoSection: 'SEO',
    seoPageTitle: 'Sayfa Başlığı',
    seoTitleLabel: 'SEO Başlığı',
    seoTitleHint: "Google'da görünecek başlık",
    seoDescSection: 'Sayfa Açıklaması',
    seoPageDesc: 'Sayfa Açıklaması',
    seoDescLabel: 'SEO Açıklaması',
    seoDescHint: "Google snippet'inde görünecek açıklama",
    seoKeywordsSection: 'Anahtar Kelimeler',
    seoKeywordsTitle: 'Anahtar Kelimeler',
    seoKeywordsLabel: 'Anahtar Kelimeler',
    seoKeywordsHint: 'Virgülle ayırarak yazın',
    seoTipsTitle: 'SEO İpuçları',
    seoTip1: 'Başlık 50-60 karakter arasında olmalı',
    seoTip2: 'Açıklama 150-160 karakter arasında olmalı',
    seoTip3: 'Anahtar kelimeleri doğal şekilde kullanın',
    seoGeoSection: 'SEO & GEO İçerikleri',
    seoGeoTitle: 'SEO & GEO İçerikleri',
    seoGeoBadge: 'Vitrin',
    seoGeoLabel: 'Vitrin',
    seoGeoDesc: 'Vitrin sayfa altı makale, AI özet ve SSS (max 10)',
    seoGeoHint: 'Vitrin sayfa altı makale, AI özet ve SSS (max 10)',
    requirementsTitle: 'Sistem Gereksinimleri',
    requirementsLabel: 'Sistem',
    requirementsField: 'Sistem Gereksinimleri (Türkçe)',
    requirementsPlaceholder: 'Minimum sistem gereksinimleri…',
    requirementsHint: 'Minimum sistem gereksinimleri',
    requirementsOther: 'Gereksinimler (diğer diller)',
    reqsTitle: 'Sistem Gereksinimleri',
    reqsBadge: 'Sistem',
    reqsTr: 'Sistem Gereksinimleri (Türkçe)',
    reqsPlaceholder: 'Minimum sistem gereksinimleri…',
    reqsHint: 'Minimum sistem gereksinimleri',
    reqsOtherLangs: 'Gereksinimler (diğer diller)',
    howToUseTitle: 'Nasıl Kullanılır',
    howToUseBadge: 'Kullanım',
    howToUseLabel: 'Kullanım',
    howToUseField: 'Kullanım Talimatları (Türkçe)',
    howToUseTr: 'Kullanım Talimatları (Türkçe)',
    howToUsePlaceholder: 'Kullanım talimatları…',
    howToUseHint: 'Kullanım talimatları',
    howToUseOther: 'Kullanım (diğer diller)',
    howToUseOtherLangs: 'Kullanım (diğer diller)',
    steamMatch: 'Steam eşleşme',
    steamMatchHint: 'Steam kataloğu ile eşlemek için uygulama kimliği (kategorideki tüm ürünler için).',
    createSuccess: 'Kategori oluşturuldu.',
    updateSuccess: 'Kategori güncellendi.',
    loadFailedForm: 'Kategori yüklenemedi.',
    nameRequired: 'Kategori adı zorunludur.',
    saveFailed: 'Kayıt başarısız.',
    translationSaved: 'Kategori kaydedildi ancak çeviriler güncellenemedi.',
    req: {
      saveFirst: 'Önce kategoriyi kaydedin; ardından bu kategorideki tüm ürünler için geçerli olacak gerekli alanları buradan tanımlayabilirsiniz.',
      hint: 'Bu alanlar kategorideki tüm ürünler için ortaktır. Top-Up ve sepet formları kategori ayarlarını kullanır.',
      productTitle: 'Satış gerekli alanları',
      productSubtitle: 'Müşteriden siparişte istenecek bilgiler',
      sellUsTitle: 'Bize sat gerekli alanları',
      sellUsSubtitle: 'Pazar yerine / bize satışta istenecek bilgiler',
      active: 'Aktif',
      passive: 'Pasif',
      noLabel: 'Hayır',
      noDesc: 'Ekstra alan istenmeyecek',
      yesLabel: 'Evet',
      yesDesc: 'Müşteriden ek bilgi alınacak',
      fieldList: 'Alan listesi',
      addField: 'Alan ekle',
      fieldNumber: 'Alan #{num}',
      fieldType: 'Alan türü',
      typeInfo: 'Bilgi mesajı',
      typeText: 'Metin girişi',
      typeOption: 'Seçenekli',
      fieldTitle: 'Başlık',
      fieldTitleHint: 'Örn. Oyuncu ID',
      fieldInfoText: 'Bilgi metni',
      fieldPlaceholder: 'Placeholder',
      fieldDefault: 'Varsayılan',
      fieldMinChar: 'Min karakter',
      fieldMaxChar: 'Max karakter',
      fieldOptions: 'Seçenekler (satır başına bir)',
      fieldImageLabel: 'Bilgi görseli',
      fieldImageOptional: '(isteğe bağlı)',
      fieldImageDesc: 'Müşteri bilgi modalında gösterilecek görsel. JPEG, PNG veya WebP — en fazla 5 MB.',
      fieldImageSaveFirst: 'Yeni alan için önce kategoriyi kaydedin; ardından bilgi görseli yükleyebilirsiniz.',
      fieldImageDescMeta: 'Görsel açıklaması',
      fieldImageUploadMsg: 'Görsel yüklemek için önce kategoriyi kaydedin.',
      fieldImageUploaded: 'Bilgi görseli yüklendi.',
      fieldImageUploadFailed: 'Görsel yüklenemedi.',
      fieldImageRemoveConfirm: 'Bilgi görselini kaldırmak istiyor musunuz?',
      fieldImageRemoved: 'Görsel kaldırıldı.',
      fieldImageRemoveFailed: 'Görsel kaldırılamadı.',
      fieldImageNoPreview: 'Önizleme yok',
      fieldImageChangeBtn: 'Görseli değiştir',
      fieldImageUploadBtn: 'Görsel yükle',
    },
    gallery: {
      title: 'Görsel galerisi',
      desc: 'Kapak alanından bağımsız ek görseller (en fazla 5 MB, yalnızca resim). Plan medya kotası geçerlidir.',
      uploaded: 'Görsel yüklendi.',
      deleted: 'Görsel silindi.',
      uploadFailed: 'Yükleme başarısız. Kota veya dosyayı kontrol edin.',
      deleteFailed: 'Silme başarısız.',
      deleteConfirm: 'Bu görseli kaldırmak istediğinize emin misiniz?',
    },
    images: {
      coverTitle: 'Kapak',
      bannerTitle: 'Banner',
      coverUploaded: 'Kapak yüklendi.',
      bannerUploaded: 'Banner yüklendi.',
      coverFailed: 'Kapak yüklenemedi.',
      bannerFailed: 'Banner yüklenemedi.',
      updateFailed: 'Güncelleme başarısız.',
      coverRemoved: 'Kapak kaldırıldı.',
      bannerRemoved: 'Banner kaldırıldı.',
      imageOnly: 'Yalnızca görsel dosyaları yüklenebilir.',
      maxSize: 'Dosya boyutu en fazla 5 MB olabilir.',
      noImage: 'Görsel yok',
      uploadBtn: 'Yükle',
      removeBtn: 'Kaldır',
      coverRemoveConfirm: 'Kapak görselini kaldır?',
      bannerRemoveConfirm: 'Banner görselini kaldır?',
    },
  },

  brands: {
    title: 'Markalar',
    new: 'Marka ekle',
    total: 'Toplam {count}',
    searchPlaceholder: 'Marka adı',
    loadFailed: 'Liste alınamadı.',
    tableWeb: 'Web',
    editTitle: 'Markayı düzenle',
    createTitle: 'Yeni marka',
    nameStar: 'Ad *',
    websiteLabel: 'Web sitesi',
    logoLabel: 'Logo',
    logoNone: 'Logo yok',
    logoUploadBtn: 'Yükle',
    logoRemoveBtn: 'Kaldır',
    logoRemoveConfirm: 'Logoyu kaldır?',
    logoHint: 'PNG veya SVG önerilir. Maks. 5 MB.',
    logoAfterSave: 'Logo kayıt sonrası yüklenecek.',
    logoUploaded: 'Logo yüklendi.',
    logoFailed: 'Logo yüklenemedi.',
    logoRemoved: 'Logo kaldırıldı.',
    logoUpdateFailed: 'Güncelleme başarısız.',
    descriptionLabel: 'Açıklama',
    activeLabel: 'Aktif',
    createSuccess: 'Marka oluşturuldu.',
    updateSuccess: 'Marka güncellendi.',
    saveFailedLogo: 'Marka kaydedildi ancak logo yüklenemedi.',
    nameRequired: 'Marka adı zorunludur.',
    actionFailed: 'İşlem başarısız.',
    imageOnly: 'Yalnızca görsel dosyaları yüklenebilir.',
    maxSize: 'Dosya boyutu en fazla 5 MB olabilir.',
    noRecords: 'Kayıt yok.',
    colName: 'Ad',
    colWebsite: 'Web',
    colStatus: 'Durum',
    newTitle: 'Yeni marka',
    fieldName: 'Ad *',
    fieldWebsite: 'Web sitesi',
    fieldDescription: 'Açıklama',
    logoSavedFailed: 'Marka kaydedildi ancak logo yüklenemedi.',
    saveFailed: 'İşlem başarısız.',
    logoAlt: 'Marka logosu',
    noLogo: 'Logo yok',
    uploadBtn: 'Yükle',
    removeBtn: 'Kaldır',
    removeConfirm: 'Logoyu kaldır?',
    logoUploadFailed: 'Logo yüklenemedi.',
  },

  categoryTypes: {
    title: 'Kategori türleri',
    new: 'Yeni tür',
    total: 'Toplam {count}',
    loadFailed: 'Liste alınamadı.',
    tableActions: 'İşlemler',
    editTitle: 'Kategori türü düzenle',
    createTitle: 'Yeni kategori türü',
    nameStar: 'Ad *',
    slugOptional: 'Slug (isteğe bağlı)',
    slugHint: 'Boş → addan üretilir',
    descriptionLabel: 'Açıklama',
    activeLabel: 'Aktif',
    saveSuccess: 'Güncellendi.',
    createSuccess: 'Oluşturuldu.',
    nameRequired: 'Ad zorunludur.',
    actionFailed: 'İşlem başarısız.',
    noRecords: 'Kayıt yok.',
    colName: 'Ad',
    colSlug: 'Slug',
    colStatus: 'Durum',
    colActions: 'İşlemler',
    newTitle: 'Yeni kategori türü',
    fieldName: 'Ad *',
    fieldSlug: 'Slug (isteğe bağlı)',
    fieldDescription: 'Açıklama',
    updateSuccess: 'Güncellendi.',
    saveFailed: 'İşlem başarısız.',
  },

  productTypes: {
    title: 'Ürün türleri',
    new: 'Yeni ürün türü',
    total: 'Toplam {count}',
    loadFailed: 'Liste alınamadı.',
    tableDigital: 'Dijital',
    tableAutoDelivery: 'Oto teslim',
    tableVirtualStock: 'Sanal stok',
    editTitle: 'Ürün türü düzenle',
    createTitle: 'Yeni ürün türü',
    nameStar: 'Ad *',
    billingPeriod: 'Faturalama periyodu (gün)',
    cancellationPolicy: 'İptal politikası',
    digital: 'Dijital ürün',
    autoDelivery: 'Otomatik teslim',
    virtualStock: 'Sanal stok',
    activeLabel: 'Aktif',
    updateSuccess: 'Ürün türü güncellendi.',
    createSuccess: 'Ürün türü oluşturuldu.',
    nameRequired: 'Ad zorunludur.',
    actionFailed: 'İşlem başarısız.',
    noRecords: 'Kayıt yok.',
    colName: 'Ad',
    colDigital: 'Dijital',
    colAutoDelivery: 'Oto teslim',
    colVirtualStock: 'Sanal stok',
    colStatus: 'Durum',
    newTitle: 'Yeni ürün türü',
    fieldName: 'Ad *',
    fieldBillingPeriod: 'Faturalama periyodu (gün)',
    fieldCancellationPolicy: 'İptal politikası',
    isDigital: 'Dijital ürün',
    isAutoDelivery: 'Otomatik teslim',
    isVirtualStock: 'Sanal stok',
    saveFailed: 'İşlem başarısız.',
  },

  platforms: {
    title: 'Kategori platformları',
    new: 'Platform ekle',
    total: 'Toplam {count}',
    desc: 'Sistemdeki platform tanımlarını yönetin. Hangi kategoride hangi platformların geçerli olduğunu kategori düzenleme ekranındaki Platform sekmesinden atayın.',
    searchPlaceholder: 'Platform adı',
    loadFailed: 'Liste alınamadı.',
    editTitle: 'Platform düzenle',
    createTitle: 'Yeni platform',
    nameStar: 'Ad *',
    slugOptional: 'Slug (isteğe bağlı)',
    slugHint: 'Boş → addan üretilir',
    logoUrl: 'Logo URL',
    descriptionLabel: 'Açıklama',
    activeLabel: 'Aktif',
    updateSuccess: 'Platform güncellendi.',
    createSuccess: 'Platform oluşturuldu.',
    nameRequired: 'Ad zorunludur.',
    actionFailed: 'İşlem başarısız.',
    noRecords: 'Kayıt yok.',
    hint: 'Sistemdeki platform tanımlarını yönetin. Hangi kategoride hangi platformların geçerli olduğunu kategori düzenleme ekranındaki Platform sekmesinden atayın.',
    colName: 'Ad',
    colSlug: 'Slug',
    colStatus: 'Durum',
    newTitle: 'Yeni platform',
    fieldName: 'Ad *',
    fieldSlug: 'Slug (isteğe bağlı)',
    fieldLogoUrl: 'Logo URL',
    fieldDescription: 'Açıklama',
    saveFailed: 'İşlem başarısız.',
  },

  stocks: {
    title: 'Stok Listesi',
    new: 'Yeni Ekle',
    total: 'Toplam {count} satır',
    productFilter: 'Ürüne göre filtre',
    deleteConfirm: 'Bu stok satırını silinsin mi?',
    deleted: 'Silindi.',
    deleteFailed: 'Silinemedi.',
    tableProduct: 'ÜRÜN',
    tableCode: 'KOD',
    tableSupplier: 'TEDARİKÇİ',
    tableCostPrice: 'ALIŞ FİYATI',
    tableSalePrice: 'SATIŞ FİYATI',
    tableStatus: 'DURUM',
    tablePriority: 'ÖNCELİK',
    tableAdded: 'EKLENME TARİHİ',
    tableExpiry: 'SKT',
    tableActions: 'İŞLEMLER',
    statusOnSale: 'Satışta',
    statusSoldOut: 'Tükendi',
    addTitle: 'Yeni Stok Ekle',
    addSubtitle: 'Birden fazla stok kodunu tek seferde ekleyebilirsiniz.',
    breadcrumb: 'Stok Listesi',
    breadcrumbNew: 'Stok Ekle',
    categorySelect: 'Kategori Seçiniz',
    productSelect: 'Ürün Seçiniz *',
    marketplaceSelect: 'Mağaza Seçiniz',
    currencySelect: 'Para Birimi *',
    updateCostLabel: 'Ürün maliyeti ve satış fiyatı güncellensin mi?',
    costlessLabel: 'Maliyetsiz Stok',
    priceTypeLabel: 'Fiyat Tipi',
    priceTypeFixed: 'Sabit',
    priceTypePercentage: 'Yüzde',
    priceTypeAmount: 'Miktar',
    updateCurrencyLabel: 'Para Birimi',
    updateAmountLabel: 'Miktar/Yüzde',
    costLabel: 'Maliyet',
    salePriceLabel: 'Satış Fiyatı',
    marketPriceLabel: 'Market Fiyatı',
    supplierSelect: 'Tedarikçi Seçiniz',
    billNumber: 'Fatura No',
    priorityLabel: 'Öncelik',
    expireAt: 'Son Kullanma Tarihi (SKT)',
    statusLabel: 'Stok Durumu',
    statusActive: 'Aktif (Satışta)',
    statusPassive: 'Pasif (Tükendi)',
    keycodesLabel: 'Elektronik Kodlar *',
    keycodesPlaceholder: 'Her satır bir kod olacak şekilde giriniz...',
    addBtn: 'Ekle',
    addingBtn: 'Ekleniyor...',
    currencyError: 'Para birimi seçin.',
    productError: 'Ürün seçin.',
    codeError: 'Lütfen ürün kodlarını giriniz.',
    actionFailed: 'İşlem başarısız.',
    successTitle: 'Başarılı İşlemler ({count})',
    failTitle: 'Başarısız İşlemler ({count})',
    codeColumn: 'KOD',
    messageColumn: 'MESAJ',
    noSuccess: 'Kayıt yok.',
    noFailed: 'Kayıt yok.',
    totalRows: 'Toplam {count} satır',
    colProduct: 'ÜRÜN',
    colCode: 'KOD',
    colSupplier: 'TEDARİKÇİ',
    colCost: 'ALIŞ FİYATI',
    colSalePrice: 'SATIŞ FİYATI',
    colStatus: 'DURUM',
    colPriority: 'ÖNCELİK',
    colCreatedAt: 'EKLENME TARİHİ',
    colExpireAt: 'SKT',
    colActions: 'İŞLEMLER',
    soldOut: 'Tükendi',
    onSale: 'Satışta',
    filterByProduct: 'Ürüne göre filtre',
    addSuccess: 'Kayıt işlemi tamamlandı.',
    selectCurrency: 'Para birimi seçin.',
    selectProduct: 'Ürün Seçiniz *',
    enterCodes: 'Lütfen ürün kodlarını giriniz.',
    saveFailed: 'İşlem başarısız.',
    selectCategory: 'Kategori Seçiniz',
    selectMarketplace: 'Mağaza Seçiniz',
    noMarketplace: 'Yok (Sistem)',
    selectCurrencyLabel: 'Para Birimi *',
    updateCostAndPrice: 'Ürün maliyeti ve satış fiyatı güncellensin mi?',
    costless: 'Maliyetsiz Stok',
    priceType: 'Fiyat Tipi',
    selectPriceType: 'Fiyat Tipi Seçin',
    amountOrPercent: 'Miktar/Yüzde',
    cost: 'Maliyet',
    salePrice: 'Satış Fiyatı',
    marketPrice: 'Market Fiyatı',
    selectSupplier: 'Tedarikçi Seçiniz',
    billNumberPlaceholder: 'Fatura No.',
    priority: 'Öncelik',
    stockStatus: 'Stok Durumu',
    selectStockStatus: 'Stok Durumu Seçin',
    keycodes: 'Elektronik Kodlar *',
    adding: 'Ekleniyor...',
    add: 'Ekle',
    colResultCode: 'KOD',
    colResultMessage: 'MESAJ',
  },

  virtualStocks: {
    title: 'Sanal Stok',
    new: 'Yeni Ekle',
    total: 'Toplam {count} kayıt',
    searchLabel: 'Stok adı',
    loadFailed: 'Liste yüklenemedi.',
    deleteConfirm: 'Bu sanal stoğu silmek istediğinize emin misiniz?',
    deleteSuccess: 'Sanal stok silindi.',
    deleteFailed: 'Silme işlemi başarısız.',
    tableStockName: 'Stok Adı',
    tableStore: 'Mağaza',
    tableUnitType: 'Birim Türü',
    tableTotalStock: 'Toplam Stok',
    tableAvgCost: 'Ort. Maliyet',
    tableCurrency: 'Para Birimi',
    tableStatus: 'Durum',
    tableActions: 'İşlemler',
    empty: 'Sanal stok bulunamadı.',
    unitPiece: 'Adet',
    unitCurrency: 'Para',
    unitDiamond: 'Elmas',
    editTitle: 'Sanal Stok Düzenle',
    createTitle: 'Sanal Stok Ekle',
    nameLabel: 'Sanal Stok Adı',
    namePlaceholder: 'Örn: 1000 RP (TR)',
    marketplaceLabel: 'Pazaryeri',
    currencyLabel: 'Para Birimi',
    totalStockLabel: 'Toplam Stok',
    unitAmountLabel: 'Birim Adedi',
    unitTypeLabel: 'Birim Türü',
    balanceStockLabel: 'Bakiye Stoğu (API)',
    avgCostLabel: 'Ortalama Maliyet',
    descriptionLabel: 'Açıklama',
    updateSuccess: 'Sanal stok güncellendi.',
    createSuccess: 'Sanal stok oluşturuldu.',
    nameRequired: 'Sanal stok adı zorunludur.',
    marketplaceRequired: 'Lütfen bir pazaryeri seçin.',
    currencyRequired: 'Lütfen para birimi seçin.',
    actionFailed: 'İşlem başarısız.',
    saving: 'Kaydediliyor...',
    totalRecords: 'Toplam {count} kayıt',
    colName: 'Stok Adı',
    colMarketplace: 'Mağaza',
    colUnitType: 'Birim Türü',
    colTotalStock: 'Toplam Stok',
    colAvgCost: 'Ort. Maliyet',
    colCurrency: 'Para Birimi',
    colStatus: 'Durum',
    colActions: 'İşlemler',
    deleted: 'Sanal stok silindi.',
    unitType_piece: 'Adet',
    unitType_currency: 'Para',
    unitType_diamond: 'Elmas',
    unitTypePiece: 'Adet',
    unitTypeCurrency: 'Para',
    unitTypeDiamond: 'Elmas',
    isBalanceStock: 'Bakiye Stoğu (API)',
    fieldMarketplace: 'Pazaryeri',
    fieldCurrency: 'Para Birimi',
    fieldTotalStock: 'Toplam Stok',
    fieldUnitAmount: 'Birim Adedi',
    fieldUnitType: 'Birim Türü',
    fieldAvgCost: 'Ortalama Maliyet',
    fieldDescription: 'Açıklama',
    saveFailed: 'İşlem başarısız.',
    selectMarketplace: 'Lütfen bir pazaryeri seçin.',
    selectCurrency: 'Lütfen para birimi seçin.',
    newTitle: 'Sanal Stok Ekle',
  },

  suppliers: {
    title: 'Tedarikçi Listesi',
    new: 'Yeni Tedarikçi',
    editTitle: 'Tedarikçi Düzenle',
    noRecords: 'Kayıt bulunamadı.',
    tableSupplier: 'Tedarikçi',
    tableWebsite: 'Website',
    tableBalance: 'Bakiye',
    tableBilling: 'Fatura',
    nameLabel: 'Tedarikçi Adı *',
    addressLabel: 'Adres',
    websiteLabel: 'Website',
    billingLabel: 'Faturalandırma',
    activeLabel: 'Aktif',
    deleteConfirm: 'Silmek istediğinizden emin misiniz?',
    saveSuccess: 'Kaydedildi.',
    deleteSuccess: 'Silindi.',
    deleteFailed: 'Silinemedi',
    adjustTitle: 'Bakiye Ayarla — {name}',
    adjustCurrent: 'Mevcut: ₺{amount}',
    adjustAmountLabel: 'Tutar (negatif = borç)',
    adjustDescLabel: 'Açıklama',
    adjustSuccess: 'Bakiye güncellendi.',
    adjustBtn: 'Uygula',
    adjustBalance: '± Bakiye',
    transactionTitle: 'Tedarikçi Hareketleri',
    transAllSuppliers: 'Tüm Tedarikçiler',
    transTableSupplier: 'Tedarikçi',
    transTableDesc: 'Açıklama',
    transTableAmount: 'Tutar',
    transTableOldBalance: 'Eski Bakiye',
    transTableNewBalance: 'Yeni Bakiye',
    transTableDate: 'Tarih',
    transEmpty: 'Kayıt yok.',
    saved: 'Kaydedildi.',
    deleted: 'Silindi.',
    balanceUpdated: 'Bakiye güncellendi.',
    adjustFailed: 'Hata.',
    newTitle: 'Yeni Tedarikçi',
    currentBalance: 'Mevcut',
    adjustApply: 'Uygula',
    transactionsTitle: 'Tedarikçi Hareketleri',
    allSuppliers: 'Tüm Tedarikçiler',
    colDescription: 'Açıklama',
    colAmount: 'Tutar',
    colOldBalance: 'Eski Bakiye',
    colNewBalance: 'Yeni Bakiye',
    colDate: 'Tarih',
  },

  common: {
    page: 'Sayfa {current} / {last}',
    searchDots: 'Ara…',
    selectDots: 'Seçiniz…',
  },
}

export const en: Dictionary = {
  products: {
    title: 'Products',
    new: 'New product',
    total: '{count} products total',
    searchPlaceholder: 'Name or SKU',
    loadFailed: 'Failed to load products. Please try again.',
    translationTitle: 'Product translations',
    translationDesc: 'JSON scope is the current filter + page. Choose a field set for long descriptions.',
    fieldName: 'Product name',
    fieldNameShort: 'Name + short description',
    fieldFull: 'Name + short + long description',
    fieldBadges: 'Badges / info',
    scopePage: 'Page {page}',
    scopeSearch: 'search: "{q}"',
    scopeCategory: 'category #{id}',
    scopeCount: '{count} products',
    tableProduct: 'Product',
    tableSku: 'SKU',
    tableType: 'Type',
    tablePrice: 'Price',
    tableUpdated: 'Updated',
    toggleActive: 'Product activated.',
    toggleInactive: 'Product deactivated.',
    statusUpdateFailed: 'Could not update status',
    nameEmpty: 'Product name cannot be empty.',
    categoryRequired: 'Category is required.',
    typeRequired: 'Product type is required.',
    bundleTitle: 'Price recipe',
    bundleHint: 'The sale price is the sum of the base products on the same marketplace. An e-pin order is fulfilled with a separate code from each base product. Top-up loads the account and does not split codes.',
    bundleSearch: 'Search a base product',
    bundleAdd: 'Add',
    bundleEmpty: 'No recipe. This product keeps its own price.',
    bundleQty: 'Qty',
    bundleAuto: 'Automatic price',
    bundleAutoHint: 'When on, changing a base price rewrites this listing. Turn it off, or edit the marketplace price, to lock it.',
    bundleSave: 'Save recipe',
    bundleSaved: 'Recipe saved.',
    bundleSaveFailed: 'Could not save the recipe.',
    bundleCalculated: 'Calculated',
    bundleCurrent: 'Listing price',
    rowSaved: 'Row saved.',
    rowsSaved: '{count} rows saved.',
    rowsPartial: '{ok} rows saved, {failed} failed.',
    rowsEditing: '{count} rows editing',
    editNew: 'New product',
    editTitle: 'Edit product',
    backToList: 'Back to products',
    nameCard: 'Product name',
    nameCardSubtitle: 'Title displayed in store',
    imageCard: 'Product image',
    imageCardSubtitle: 'Cover and banner',
    optionsCard: 'Product options',
    optionsCardSubtitle: 'Status and category',
    categoryTreeCard: 'Category tree',
    categoryTreeSubtitle: 'Selected category and hierarchy',
    parentLabel: 'Parent:',
    childCategories: 'Subcategories',
    editCategoryLink: 'Edit category →',
    detailsCard: 'Product details',
    detailsSubtitle: 'Description, SEO, age and inventory (images in the left card)',
    tabDescriptionSettings: 'Description & Settings',
    tabInventory: 'Variants & stock',
    tabMarketplace: 'Store prices',
    categorySettingsHint: 'Age labels, platform, region, Steam mapping and required fields are managed through the category.',
    categorySettingsLink: 'Go to category settings',
    noCategoryHint: 'Select a category first for age, platform, region and required fields; then manage through the category form.',
    sectionDescription: 'Description',
    infoLabelText: 'Info label text (Turkish)',
    infoLabelOther: 'Info label (other languages)',
    labelColor: 'Label color',
    badgesHint: 'Product card badges: campaign on the image; coupon and installment in the advantage row.',
    campaignBadge: 'Campaign badge',
    campaignBadgeHint: 'e.g. Summer Campaign — on the product image',
    couponBadge: 'Coupon advantage',
    couponBadgeHint: 'e.g. Extra 10 TL Coupon',
    installmentBadge: 'Installment advantage',
    installmentBadgeHint: 'e.g. 9 × 1,250 TL at cash price',
    shortDescription: 'Short description (Turkish)',
    shortDescriptionOther: 'Short description (other languages)',
    longDescription: 'Long description (Turkish)',
    longDescriptionOther: 'Long description (other languages)',
    longDescriptionPlaceholder: 'Edit the product description…',
    sectionSettings: 'Settings',
    billingSection: 'Billing',
    billingName: 'Product name on invoice',
    billingNameHint: 'If empty, the store name is used.',
    productType: 'Product type',
    skuOptional: 'SKU (optional)',
    marketPrice: 'Market price',
    publishDate: 'Publish date',
    validationError: 'Name, category and product type are required.',
    saveFailedMessage: 'Save failed. Check the fields.',
    createSuccess: 'Product created.',
    updateSuccess: 'Product updated.',
    loadFailedForm: 'Failed to load product.',
    saving: 'Saving…',
    noProductTypes: 'No active product types in the tenant database. Add a record to the product_types table first to create a product.',
    inventoryAfterSave: 'Manage variants and stock rows from the "Variants & stock" tab after saving the product.',
    imagesAfterSave: 'After saving, manage cover, banner and gallery images from the left card.',
    colorNone: 'None',
    colorRed: 'Red',
    colorGreen: 'Green',
    colorBlue: 'Blue',
    colorYellow: 'Yellow',
    published: 'Published',
    seo: {
      urlTitle: 'SEO URL',
      urlHint: 'lowercase, numbers and hyphens',
      slugLabel: 'URL slug',
      slugHintNew: 'e.g. example-product (lowercase, numbers, hyphens)',
      slugHintExisting: 'Current: {slug}',
      metaTitleCard: 'Meta title',
      metaTitleHint: '~60 characters recommended',
      metaTitleLabel: 'Meta title',
      metaDescCard: 'Meta description',
      metaDescHint: '~160 characters; use keywords naturally',
      metaDescLabel: 'Meta description',
      keywordsCard: 'Meta keywords',
      keywordsHint: 'separate with commas',
      keywordsLabel: 'Keywords',
      keywordsFieldHint: 'Separate with commas.',
      extraCard: 'Additional SEO settings',
      extraHint: '(GA and sharing image; 1200×630 recommended for image)',
      ogImageLabel: 'Share image URL',
      ogImageHint: '1200×630 recommended. File upload coming soon.',
      geoCard: 'Page footer SEO & GEO',
      geoHint: '(shown in storefront product detail)',
      previewCard: 'Search engine preview',
      multilingualSoon: 'Multilingual content coming soon',
      pageTitle: 'Page title',
      pageDesc: 'The description text shown in search results goes here.',
      exampleSlug: 'example-product',
      slugPlaceholder: 'example-product',
      previewTitleFallback: 'Page title',
      previewDescFallback: 'The description text shown in search results goes here.',
      seoUrl: 'SEO URL',
      seoUrlHint: 'lowercase, numbers and hyphens',
      urlSlug: 'URL slug',
      slugNewHint: 'e.g. example-product (lowercase, numbers, hyphens)',
      slugExistingHint: 'Current: {slug}',
      metaTitle: 'Meta title',
      metaDesc: 'Meta description',
      metaKeywords: 'Meta keywords',
      metaKeywordsHint: 'separate with commas',
      metaKeywordsInputHint: 'Separate with commas.',
      extraSettings: 'Additional SEO settings',
      extraSettingsHint: 'GA and sharing image; 1200×630 recommended for image',
      gaId: 'Google Analytics ID',
      gaIdHint: 'G-XXXXXXXXXX or UA-XXXXXXX-X',
      ogImageUrl: 'Share image URL',
      seoGeoTitle: 'Page footer SEO & GEO',
      seoGeoHint: 'shown in storefront product detail',
      previewTitle: 'Search engine preview',
      previewHint: 'Google result simulation',
    },
    platforms: {
      loading: 'Loading platforms…',
      error: 'Failed to load platform list. Check your network connection.',
      title: 'Platforms',
      system: 'System',
      desc: 'Check the applicable platforms for all products in this category. Use the Category Platforms menu to add new platforms.',
      empty: 'No active platform records in the tenant database. Add one from the Platforms menu first.',
    },
    regions: {
      loading: 'Loading regions…',
      error: 'Failed to load country list.',
      selectedTitle: 'Selected countries',
      selectedBadge: 'Active · {count}',
      searchSelected: 'Search selected countries…',
      noSelected: 'No countries selected yet. Add from below.',
      allTitle: 'All countries',
      searchAll: 'Search all countries…',
      emptyTenant: 'Tenant region table is empty.',
      emptyFilter: 'No countries match your search or are available to add.',
      available: 'Available',
    },
    age: {
      hint: 'Check USK, ESRB and PEGI labels for display on the product card. Multiple selections are architecturally possible; only the first applicable is shown in the storefront.',
      germany: 'Germany',
      america: 'Americas',
      europe: 'Europe',
    },
    req: {
      saveFirst: 'Save the product first; then define required fields for sale and "sell to us" here.',
      productTitle: 'Product required fields',
      productSubtitle: 'Additional info to collect from the customer on sale',
      sellUsTitle: 'Sell-to-us required fields',
      sellUsSubtitle: 'Info to collect for marketplace / sell-to-us transactions',
      active: 'Active',
      passive: 'Inactive',
      noLabel: 'No',
      noDesc: 'No extra fields required',
      yesLabel: 'Yes',
      yesDesc: 'Collect additional info from customer',
      fieldList: 'Field list',
      addField: 'Add field',
      fieldNumber: 'Field #{num}',
      fieldType: 'Field type',
      typeInfo: 'Info message',
      typeText: 'Text input',
      typeOption: 'Select options',
      fieldTitle: 'Title',
      fieldTitleHint: 'e.g. Steam username',
      fieldInfoText: 'Info text',
      fieldPlaceholder: 'Placeholder',
      fieldDefault: 'Default',
      fieldMinChar: 'Min characters',
      fieldMaxChar: 'Max characters',
      fieldOptions: 'Options (one per line)',
      fieldImageLabel: 'Info image',
      fieldImageOptional: '(optional)',
      fieldImageDesc: 'Image shown in customer info modal. JPEG, PNG or WebP — max 5 MB.',
      fieldImageSaveFirst: 'Save the product first to upload an info image for a new field.',
      fieldImageDescMeta: 'Image description',
      fieldImageUploadMsg: 'Save the product first to upload an image.',
      fieldImageUploaded: 'Info image uploaded.',
      fieldImageUploadFailed: 'Failed to upload image.',
      fieldImageRemoveConfirm: 'Remove the info image?',
      fieldImageRemoved: 'Image removed.',
      fieldImageRemoveFailed: 'Failed to remove image.',
      fieldImageNoPreview: 'No preview',
      fieldImageChangeBtn: 'Change image',
      fieldImageUploadBtn: 'Upload image',
    },
    reqFields: {
      no: 'No',
      noHint: 'No extra fields required',
      yes: 'Yes',
      yesHint: 'Collect additional info from customer',
      fieldList: 'Field list',
      addField: 'Add field',
      fieldNumber: 'Field #{n}',
      fieldType: 'Field type',
      typeInfo: 'Info message',
      typeText: 'Text input',
      typeOption: 'Select options',
      fieldTitle: 'Title',
      fieldTitleHint: 'e.g. Steam username',
      infoText: 'Info text',
      placeholder: 'Placeholder',
      defaultValue: 'Default',
      minChar: 'Min characters',
      maxChar: 'Max characters',
      options: 'Options (one per line)',
      imageCaption: 'Image description',
      saveFirst: 'Save the product first; then define required fields for sale and "sell to us" here.',
      productTitle: 'Product required fields',
      productSubtitle: 'Additional info to collect from the customer on sale',
      sellUsTitle: 'Sell-to-us required fields',
      sellUsSubtitle: 'Info to collect for marketplace / sell-to-us transactions',
    },
    marketplace: {
      title: 'Store prices',
      desc: "Manage this product's sale, buy and dealer prices across stores.",
      addBtn: 'Add to store',
      store: 'Store',
      sale: 'Sale',
      buy: 'Buy',
      dealer: 'Dealer',
      virtualStock: 'Virtual stock',
      empty: 'This product has not been added to any store yet.',
      deleteConfirm: 'Are you sure you want to delete this store price record?',
      deleteSuccess: 'Store price deleted.',
      deleteFailed: 'Could not delete',
    },
    variants: {
      title: 'Variants',
      addBtn: 'Add variant',
      empty: 'No variants yet.',
      editTitle: 'Edit variant',
      addTitle: 'Add variant',
      saved: 'Variant updated.',
      added: 'Variant added.',
      deleted: 'Variant deleted.',
      nameRequired: 'Variant name is required.',
      nameLabel: 'Variant name *',
      description: 'Description',
      order: 'Order',
      activeLabel: 'Active',
      deleteConfirm: 'Are you sure you want to delete this variant?',
      actionFailed: 'Action failed.',
      deleteFailed: 'Could not delete.',
    },
    stocks: {
      title: 'Stock rows',
      allList: 'Full stock list',
      addBtn: 'Add stock',
      empty: 'No stock rows yet.',
      noCurrency: 'No currency defined. Add a currencies record in the tenant database.',
      editTitle: 'Edit stock',
      addTitle: 'Add stock',
      saved: 'Stock updated.',
      added: 'Stock row added.',
      deleted: 'Stock row deleted.',
      currencyRequired: 'Select a currency.',
      codeRequired: 'Product code is required.',
      actionFailed: 'Action failed.',
      deleteFailed: 'Could not delete.',
      productLabel: 'Product: /{slug}',
      codeLabel: 'Product code *',
      barcode: 'Barcode',
      currencyLabel: 'Currency *',
      variantLabel: 'Variant (optional)',
      variantNone: 'None (main product)',
      salePrice: 'Sale price',
      cost: 'Cost',
      marketPrice: 'Market price',
      statusOnSale: 'On sale',
      statusSoldOut: 'Sold out',
      activeLabel: 'Active',
      salePriceLabel: 'Sale: {price}',
      deleteConfirm: 'Are you sure you want to delete this stock row?',
    },
    images: {
      coverTitle: 'Cover',
      coverDesc: 'Main image displayed in listings and product cards.',
      coverBadge: '1:1 recommended',
      bannerTitle: 'Banner',
      bannerDesc: 'Optional banner for the top strip / storefront area.',
      bannerBadge: '1440×600px · landscape',
      galleryTitle: 'Gallery',
      galleryDesc: 'Additional product photos. Records persist unless deleted; click the thumbnails above to set as cover or banner.',
      uploadRulesTitle: 'Upload rules',
      uploadRule1: 'Images only (JPEG, PNG, WebP, GIF); max 5 MB per file.',
      uploadRule2: 'Previews below are in a 1:1 box; use square sources when possible — looks better in listings and cards.',
      uploadRule3: 'Upload is rejected if the plan media quota (media_library) is exceeded.',
      coverUpdated: 'Cover updated.',
      bannerUpdated: 'Banner updated.',
      updateFailed: 'Update failed.',
      coverUploaded: 'Cover uploaded.',
      bannerUploaded: 'Banner uploaded.',
      uploadFailed: 'Upload failed. Check quota or file.',
      bannerFailed: 'Banner upload failed.',
      galleryAdded: 'Added to gallery.',
      galleryDeleted: 'Image deleted.',
      coverRemoved: 'Cover removed.',
      bannerRemoved: 'Banner removed.',
      noImage: 'None yet',
      uploading: 'Uploading…',
      uploadBtn: 'Upload',
      removeBtn: 'Remove',
      coverRemoveConfirm: 'Remove cover image?',
      bannerRemoveConfirm: 'Remove banner image?',
      galleryRemoveConfirm: 'Remove this image from the gallery?',
      pickFromGallery: 'Pick from gallery',
      selectImage: 'Select this image',
      imageOnly: 'Only image files can be uploaded (JPEG, PNG, WebP, GIF, etc.).',
      maxSize: 'File size must not exceed 5 MB (server rule).',
    },
  },

  categories: {
    title: 'Categories',
    new: 'New category',
    total: '{count} records total',
    searchPlaceholder: 'Category name',
    loadFailed: 'Failed to load list.',
    translationTitle: 'Category translations',
    translationDesc: 'JSON scope is the current search + page. Choose a separate set for long HTML fields.',
    fieldName: 'Category name',
    fieldNameDesc: 'Name + description',
    fieldGuides: 'How to use + system requirements',
    fieldFull: 'All text fields',
    scopePage: 'Page {page}',
    scopeSearch: 'search: "{q}"',
    scopeCount: '{count} categories',
    tableCategory: 'Category',
    tableParent: 'Parent',
    tableType: 'Type',
    tableBrand: 'Brand',
    tableVat: 'VAT %',
    toggleActive: 'Category activated.',
    toggleInactive: 'Category deactivated.',
    statusUpdateFailed: 'Could not update status',
    nameEmpty: 'Category name cannot be empty.',
    selfParent: 'A category cannot be its own parent.',
    rowSaved: 'Row saved.',
    rowsSaved: '{count} rows saved.',
    rowsPartial: '{ok} rows saved, {failed} failed.',
    rowsEditing: '{count} rows editing',
    editNew: 'New category',
    editTitle: 'Edit category',
    backToList: 'Back to list',
    copyTitle: 'Duplicate category',
    deleteTitle: 'Delete category',
    copyLabel: 'Duplicate',
    saving: 'Saving…',
    saveChanges: 'Save changes',
    nameCard: 'Category Name',
    nameCardSubtitle: 'Set a unique name for the category',
    slugOptional: 'Slug (optional)',
    slugHint: 'Left empty, generated from name',
    slugReadonlyLabel: 'Page URL',
    slugReadonlyPrefix: '/category/',
    imagesCard: 'Category images',
    imagesCardSubtitle: 'Cover and banner (ImageMan)',
    imagesAfterSave: 'After saving the category you can upload cover and banner images.',
    optionsCard: 'Category Options',
    optionsCardSubtitle: 'Category status and hierarchy settings',
    parentCategoryLabel: 'Parent Category',
    parentHint: 'Select a parent to create a subcategory',
    parentNone: 'Root Category (no parent)',
    statusCard: 'Category Status',
    statusVisible: 'Active categories are visible to users',
    treeCard: 'Category Tree',
    treeSubtitle: 'Category hierarchy structure',
    treeEmpty: 'No categories yet.',
    treeCurrent: 'Current',
    treeRoot: 'Root',
    detailsCard: 'Category details',
    detailsSubtitle: 'Settings, content, SEO and gallery (name and images in the left card)',
    tabSettings: 'Settings',
    tabDescription: 'Description',
    tabSeo: 'Meta SEO',
    tabGallery: 'Gallery',
    tabRequiredFields: 'Required Fields',
    tabRequirements: 'Requirements',
    tabHowToUse: 'How to Use',
    tabAge: 'Age',
    tabPlatform: 'Platform',
    tabRegion: 'Region',
    settingsTitle: 'Category Settings',
    settingsConfig: 'Configuration',
    categoryType: 'Category Type',
    brand: 'Brand / Publisher',
    pageView: 'Page View',
    pageViewList: 'List View',
    pageViewGrid: 'Grid View',
    pageViewDetail: 'Detailed Search',
    orderLabel: 'Order',
    taxLabel: 'Tax (%)',
    taxHint: 'e.g. 20',
    releaseYear: 'Release Date',
    releaseYearHint: 'e.g. 2024',
    languageField: 'Language',
    languageHint: 'e.g. English',
    regionField: 'Region',
    regionHint: 'e.g. TR',
    website: 'Website',
    billingSection: 'Billing',
    billingQuestion: 'Should invoices be generated for this category?',
    notSelected: 'Not selected',
    descriptionTitle: 'Category Description',
    descriptionContent: 'Content',
    descriptionLabel: 'Description (Turkish)',
    descriptionPlaceholder: 'Detailed information about the category…',
    descriptionHint: 'Detailed information about the category',
    descriptionOther: 'Description (other languages)',
    descTr: 'Description (Turkish)',
    descPlaceholder: 'Detailed information about the category…',
    descHint: 'Detailed information about the category',
    descOtherLangs: 'Description (other languages)',
    seoMetaSection: 'Meta Tags',
    seoMetaTitle: 'Meta Tags',
    seoSection: 'SEO',
    seoPageTitle: 'Page Title',
    seoTitleLabel: 'SEO Title',
    seoTitleHint: 'Title shown in Google',
    seoDescSection: 'Page Description',
    seoPageDesc: 'Page Description',
    seoDescLabel: 'SEO Description',
    seoDescHint: 'Description shown in Google snippets',
    seoKeywordsSection: 'Keywords',
    seoKeywordsTitle: 'Keywords',
    seoKeywordsLabel: 'Keywords',
    seoKeywordsHint: 'Separate with commas',
    seoTipsTitle: 'SEO Tips',
    seoTip1: 'Title should be between 50–60 characters',
    seoTip2: 'Description should be between 150–160 characters',
    seoTip3: 'Use keywords naturally',
    seoGeoSection: 'SEO & GEO Content',
    seoGeoTitle: 'SEO & GEO Content',
    seoGeoBadge: 'Storefront',
    seoGeoLabel: 'Storefront',
    seoGeoDesc: 'Storefront page-footer article, AI summary and FAQ (max 10)',
    seoGeoHint: 'Storefront page-footer article, AI summary and FAQ (max 10)',
    requirementsTitle: 'System Requirements',
    requirementsLabel: 'System',
    requirementsField: 'System Requirements (Turkish)',
    requirementsPlaceholder: 'Minimum system requirements…',
    requirementsHint: 'Minimum system requirements',
    requirementsOther: 'Requirements (other languages)',
    reqsTitle: 'System Requirements',
    reqsBadge: 'System',
    reqsTr: 'System Requirements (Turkish)',
    reqsPlaceholder: 'Minimum system requirements…',
    reqsHint: 'Minimum system requirements',
    reqsOtherLangs: 'Requirements (other languages)',
    howToUseTitle: 'How to Use',
    howToUseBadge: 'Usage',
    howToUseLabel: 'Usage',
    howToUseField: 'Usage Instructions (Turkish)',
    howToUseTr: 'Usage Instructions (Turkish)',
    howToUsePlaceholder: 'Usage instructions…',
    howToUseHint: 'Usage instructions',
    howToUseOther: 'How to use (other languages)',
    howToUseOtherLangs: 'How to use (other languages)',
    steamMatch: 'Steam mapping',
    steamMatchHint: 'App ID to map to the Steam catalogue (applies to all products in this category).',
    createSuccess: 'Category created.',
    updateSuccess: 'Category updated.',
    loadFailedForm: 'Failed to load category.',
    nameRequired: 'Category name is required.',
    saveFailed: 'Save failed.',
    translationSaved: 'Category saved but translations could not be updated.',
    req: {
      saveFirst: 'Save the category first; then define the required fields that will apply to all products in this category.',
      hint: 'These fields apply to all products in this category. Top-Up and cart forms use the category settings.',
      productTitle: 'Sale required fields',
      productSubtitle: 'Info to collect from the customer at checkout',
      sellUsTitle: 'Sell-to-us required fields',
      sellUsSubtitle: 'Info to collect for marketplace / sell-to-us transactions',
      active: 'Active',
      passive: 'Inactive',
      noLabel: 'No',
      noDesc: 'No extra fields required',
      yesLabel: 'Yes',
      yesDesc: 'Collect additional info from customer',
      fieldList: 'Field list',
      addField: 'Add field',
      fieldNumber: 'Field #{num}',
      fieldType: 'Field type',
      typeInfo: 'Info message',
      typeText: 'Text input',
      typeOption: 'Select options',
      fieldTitle: 'Title',
      fieldTitleHint: 'e.g. Player ID',
      fieldInfoText: 'Info text',
      fieldPlaceholder: 'Placeholder',
      fieldDefault: 'Default',
      fieldMinChar: 'Min characters',
      fieldMaxChar: 'Max characters',
      fieldOptions: 'Options (one per line)',
      fieldImageLabel: 'Info image',
      fieldImageOptional: '(optional)',
      fieldImageDesc: 'Image shown in customer info modal. JPEG, PNG or WebP — max 5 MB.',
      fieldImageSaveFirst: 'Save the category first to upload an info image for a new field.',
      fieldImageDescMeta: 'Image description',
      fieldImageUploadMsg: 'Save the category first to upload an image.',
      fieldImageUploaded: 'Info image uploaded.',
      fieldImageUploadFailed: 'Failed to upload image.',
      fieldImageRemoveConfirm: 'Remove the info image?',
      fieldImageRemoved: 'Image removed.',
      fieldImageRemoveFailed: 'Failed to remove image.',
      fieldImageNoPreview: 'No preview',
      fieldImageChangeBtn: 'Change image',
      fieldImageUploadBtn: 'Upload image',
    },
    gallery: {
      title: 'Image gallery',
      desc: 'Additional images independent of the cover (max 5 MB, images only). Plan media quota applies.',
      uploaded: 'Image uploaded.',
      deleted: 'Image deleted.',
      uploadFailed: 'Upload failed. Check quota or file.',
      deleteFailed: 'Delete failed.',
      deleteConfirm: 'Are you sure you want to remove this image?',
    },
    images: {
      coverTitle: 'Cover',
      bannerTitle: 'Banner',
      coverUploaded: 'Cover uploaded.',
      bannerUploaded: 'Banner uploaded.',
      coverFailed: 'Cover upload failed.',
      bannerFailed: 'Banner upload failed.',
      updateFailed: 'Update failed.',
      coverRemoved: 'Cover removed.',
      bannerRemoved: 'Banner removed.',
      imageOnly: 'Only image files can be uploaded.',
      maxSize: 'File size must not exceed 5 MB.',
      noImage: 'No image',
      uploadBtn: 'Upload',
      removeBtn: 'Remove',
      coverRemoveConfirm: 'Remove cover image?',
      bannerRemoveConfirm: 'Remove banner image?',
    },
  },

  brands: {
    title: 'Brands',
    new: 'Add brand',
    total: '{count} total',
    searchPlaceholder: 'Brand name',
    loadFailed: 'Failed to load list.',
    tableWeb: 'Web',
    editTitle: 'Edit brand',
    createTitle: 'New brand',
    nameStar: 'Name *',
    websiteLabel: 'Website',
    logoLabel: 'Logo',
    logoNone: 'No logo',
    logoUploadBtn: 'Upload',
    logoRemoveBtn: 'Remove',
    logoRemoveConfirm: 'Remove logo?',
    logoHint: 'PNG or SVG recommended. Max 5 MB.',
    logoAfterSave: 'Logo will be uploaded after saving.',
    logoUploaded: 'Logo uploaded.',
    logoFailed: 'Logo upload failed.',
    logoRemoved: 'Logo removed.',
    logoUpdateFailed: 'Update failed.',
    descriptionLabel: 'Description',
    activeLabel: 'Active',
    createSuccess: 'Brand created.',
    updateSuccess: 'Brand updated.',
    saveFailedLogo: 'Brand saved but logo could not be uploaded.',
    nameRequired: 'Brand name is required.',
    actionFailed: 'Action failed.',
    imageOnly: 'Only image files can be uploaded.',
    maxSize: 'File size must not exceed 5 MB.',
    noRecords: 'No records.',
    colName: 'Name',
    colWebsite: 'Web',
    colStatus: 'Status',
    newTitle: 'New brand',
    fieldName: 'Name *',
    fieldWebsite: 'Website',
    fieldDescription: 'Description',
    logoSavedFailed: 'Brand saved but logo could not be uploaded.',
    saveFailed: 'Action failed.',
    logoAlt: 'Brand logo',
    noLogo: 'No logo',
    uploadBtn: 'Upload',
    removeBtn: 'Remove',
    removeConfirm: 'Remove logo?',
    logoUploadFailed: 'Logo upload failed.',
  },

  categoryTypes: {
    title: 'Category types',
    new: 'New type',
    total: '{count} total',
    loadFailed: 'Failed to load list.',
    tableActions: 'Actions',
    editTitle: 'Edit category type',
    createTitle: 'New category type',
    nameStar: 'Name *',
    slugOptional: 'Slug (optional)',
    slugHint: 'Empty → generated from name',
    descriptionLabel: 'Description',
    activeLabel: 'Active',
    saveSuccess: 'Updated.',
    createSuccess: 'Created.',
    nameRequired: 'Name is required.',
    actionFailed: 'Action failed.',
    noRecords: 'No records.',
    colName: 'Name',
    colSlug: 'Slug',
    colStatus: 'Status',
    colActions: 'Actions',
    newTitle: 'New category type',
    fieldName: 'Name *',
    fieldSlug: 'Slug (optional)',
    fieldDescription: 'Description',
    updateSuccess: 'Updated.',
    saveFailed: 'Action failed.',
  },

  productTypes: {
    title: 'Product types',
    new: 'New product type',
    total: '{count} total',
    loadFailed: 'Failed to load list.',
    tableDigital: 'Digital',
    tableAutoDelivery: 'Auto delivery',
    tableVirtualStock: 'Virtual stock',
    editTitle: 'Edit product type',
    createTitle: 'New product type',
    nameStar: 'Name *',
    billingPeriod: 'Billing period (days)',
    cancellationPolicy: 'Cancellation policy',
    digital: 'Digital product',
    autoDelivery: 'Auto delivery',
    virtualStock: 'Virtual stock',
    activeLabel: 'Active',
    updateSuccess: 'Product type updated.',
    createSuccess: 'Product type created.',
    nameRequired: 'Name is required.',
    actionFailed: 'Action failed.',
    noRecords: 'No records.',
    colName: 'Name',
    colDigital: 'Digital',
    colAutoDelivery: 'Auto delivery',
    colVirtualStock: 'Virtual stock',
    colStatus: 'Status',
    newTitle: 'New product type',
    fieldName: 'Name *',
    fieldBillingPeriod: 'Billing period (days)',
    fieldCancellationPolicy: 'Cancellation policy',
    isDigital: 'Digital product',
    isAutoDelivery: 'Auto delivery',
    isVirtualStock: 'Virtual stock',
    saveFailed: 'Action failed.',
  },

  platforms: {
    title: 'Category platforms',
    new: 'Add platform',
    total: '{count} total',
    desc: 'Manage platform definitions in the system. Assign which platforms apply to a category from the Platform tab in the category editor.',
    searchPlaceholder: 'Platform name',
    loadFailed: 'Failed to load list.',
    editTitle: 'Edit platform',
    createTitle: 'New platform',
    nameStar: 'Name *',
    slugOptional: 'Slug (optional)',
    slugHint: 'Empty → generated from name',
    logoUrl: 'Logo URL',
    descriptionLabel: 'Description',
    activeLabel: 'Active',
    updateSuccess: 'Platform updated.',
    createSuccess: 'Platform created.',
    nameRequired: 'Name is required.',
    actionFailed: 'Action failed.',
    noRecords: 'No records.',
    hint: 'Manage platform definitions in the system. Assign which platforms apply to a category from the Platform tab in the category editor.',
    colName: 'Name',
    colSlug: 'Slug',
    colStatus: 'Status',
    newTitle: 'New platform',
    fieldName: 'Name *',
    fieldSlug: 'Slug (optional)',
    fieldLogoUrl: 'Logo URL',
    fieldDescription: 'Description',
    saveFailed: 'Action failed.',
  },

  stocks: {
    title: 'Stock List',
    new: 'Add new',
    total: '{count} rows total',
    productFilter: 'Filter by product',
    deleteConfirm: 'Delete this stock row?',
    deleted: 'Deleted.',
    deleteFailed: 'Could not delete.',
    tableProduct: 'PRODUCT',
    tableCode: 'CODE',
    tableSupplier: 'SUPPLIER',
    tableCostPrice: 'COST PRICE',
    tableSalePrice: 'SALE PRICE',
    tableStatus: 'STATUS',
    tablePriority: 'PRIORITY',
    tableAdded: 'ADDED DATE',
    tableExpiry: 'EXP.',
    tableActions: 'ACTIONS',
    statusOnSale: 'On sale',
    statusSoldOut: 'Sold out',
    addTitle: 'Add New Stock',
    addSubtitle: 'You can add multiple stock codes at once.',
    breadcrumb: 'Stock List',
    breadcrumbNew: 'Add Stock',
    categorySelect: 'Select Category',
    productSelect: 'Select Product *',
    marketplaceSelect: 'Select Store',
    currencySelect: 'Currency *',
    updateCostLabel: 'Update product cost and sale price?',
    costlessLabel: 'Cost-free Stock',
    priceTypeLabel: 'Price Type',
    priceTypeFixed: 'Fixed',
    priceTypePercentage: 'Percentage',
    priceTypeAmount: 'Amount',
    updateCurrencyLabel: 'Currency',
    updateAmountLabel: 'Amount / Percentage',
    costLabel: 'Cost',
    salePriceLabel: 'Sale Price',
    marketPriceLabel: 'Market Price',
    supplierSelect: 'Select Supplier',
    billNumber: 'Invoice No.',
    priorityLabel: 'Priority',
    expireAt: 'Expiry Date',
    statusLabel: 'Stock Status',
    statusActive: 'Active (On sale)',
    statusPassive: 'Inactive (Sold out)',
    keycodesLabel: 'Electronic Codes *',
    keycodesPlaceholder: 'One code per line…',
    addBtn: 'Add',
    addingBtn: 'Adding...',
    currencyError: 'Select a currency.',
    productError: 'Select a product.',
    codeError: 'Please enter product codes.',
    actionFailed: 'Action failed.',
    successTitle: 'Successful ({count})',
    failTitle: 'Failed ({count})',
    codeColumn: 'CODE',
    messageColumn: 'MESSAGE',
    noSuccess: 'No records.',
    noFailed: 'No records.',
    totalRows: '{count} rows total',
    colProduct: 'PRODUCT',
    colCode: 'CODE',
    colSupplier: 'SUPPLIER',
    colCost: 'COST PRICE',
    colSalePrice: 'SALE PRICE',
    colStatus: 'STATUS',
    colPriority: 'PRIORITY',
    colCreatedAt: 'ADDED DATE',
    colExpireAt: 'EXP.',
    colActions: 'ACTIONS',
    soldOut: 'Sold out',
    onSale: 'On sale',
    filterByProduct: 'Filter by product',
    addSuccess: 'Records added successfully.',
    selectCurrency: 'Select a currency.',
    selectProduct: 'Select Product *',
    enterCodes: 'Please enter product codes.',
    saveFailed: 'Action failed.',
    selectCategory: 'Select Category',
    selectMarketplace: 'Select Store',
    noMarketplace: 'None (System)',
    selectCurrencyLabel: 'Currency *',
    updateCostAndPrice: 'Update product cost and sale price?',
    costless: 'Cost-free Stock',
    priceType: 'Price Type',
    selectPriceType: 'Select Price Type',
    amountOrPercent: 'Amount / Percentage',
    cost: 'Cost',
    salePrice: 'Sale Price',
    marketPrice: 'Market Price',
    selectSupplier: 'Select Supplier',
    billNumberPlaceholder: 'Invoice No.',
    priority: 'Priority',
    stockStatus: 'Stock Status',
    selectStockStatus: 'Select Stock Status',
    keycodes: 'Electronic Codes *',
    adding: 'Adding...',
    add: 'Add',
    colResultCode: 'CODE',
    colResultMessage: 'MESSAGE',
  },

  virtualStocks: {
    title: 'Virtual Stock',
    new: 'Add new',
    total: '{count} records total',
    searchLabel: 'Stock name',
    loadFailed: 'Failed to load list.',
    deleteConfirm: 'Are you sure you want to delete this virtual stock?',
    deleteSuccess: 'Virtual stock deleted.',
    deleteFailed: 'Delete action failed.',
    tableStockName: 'Stock Name',
    tableStore: 'Store',
    tableUnitType: 'Unit Type',
    tableTotalStock: 'Total Stock',
    tableAvgCost: 'Avg. Cost',
    tableCurrency: 'Currency',
    tableStatus: 'Status',
    tableActions: 'Actions',
    empty: 'No virtual stocks found.',
    unitPiece: 'Piece',
    unitCurrency: 'Currency',
    unitDiamond: 'Diamond',
    editTitle: 'Edit Virtual Stock',
    createTitle: 'Add Virtual Stock',
    nameLabel: 'Virtual Stock Name',
    namePlaceholder: 'e.g. 1000 RP (TR)',
    marketplaceLabel: 'Marketplace',
    currencyLabel: 'Currency',
    totalStockLabel: 'Total Stock',
    unitAmountLabel: 'Unit Amount',
    unitTypeLabel: 'Unit Type',
    balanceStockLabel: 'Balance Stock (API)',
    avgCostLabel: 'Average Cost',
    descriptionLabel: 'Description',
    updateSuccess: 'Virtual stock updated.',
    createSuccess: 'Virtual stock created.',
    nameRequired: 'Virtual stock name is required.',
    marketplaceRequired: 'Please select a marketplace.',
    currencyRequired: 'Please select a currency.',
    actionFailed: 'Action failed.',
    saving: 'Saving...',
    totalRecords: '{count} records total',
    colName: 'Stock Name',
    colMarketplace: 'Store',
    colUnitType: 'Unit Type',
    colTotalStock: 'Total Stock',
    colAvgCost: 'Avg. Cost',
    colCurrency: 'Currency',
    colStatus: 'Status',
    colActions: 'Actions',
    deleted: 'Virtual stock deleted.',
    unitType_piece: 'Piece',
    unitType_currency: 'Currency',
    unitType_diamond: 'Diamond',
    unitTypePiece: 'Piece',
    unitTypeCurrency: 'Currency',
    unitTypeDiamond: 'Diamond',
    isBalanceStock: 'Balance Stock (API)',
    fieldMarketplace: 'Marketplace',
    fieldCurrency: 'Currency',
    fieldTotalStock: 'Total Stock',
    fieldUnitAmount: 'Unit Amount',
    fieldUnitType: 'Unit Type',
    fieldAvgCost: 'Average Cost',
    fieldDescription: 'Description',
    saveFailed: 'Action failed.',
    selectMarketplace: 'Please select a marketplace.',
    selectCurrency: 'Please select a currency.',
    newTitle: 'Add Virtual Stock',
  },

  suppliers: {
    title: 'Supplier List',
    new: 'New Supplier',
    editTitle: 'Edit Supplier',
    noRecords: 'No records found.',
    tableSupplier: 'Supplier',
    tableWebsite: 'Website',
    tableBalance: 'Balance',
    tableBilling: 'Billing',
    nameLabel: 'Supplier Name *',
    addressLabel: 'Address',
    websiteLabel: 'Website',
    billingLabel: 'Billing',
    activeLabel: 'Active',
    deleteConfirm: 'Are you sure you want to delete this?',
    saveSuccess: 'Saved.',
    deleteSuccess: 'Deleted.',
    deleteFailed: 'Could not delete',
    adjustTitle: 'Adjust Balance — {name}',
    adjustCurrent: 'Current: ₺{amount}',
    adjustAmountLabel: 'Amount (negative = debt)',
    adjustDescLabel: 'Description',
    adjustSuccess: 'Balance updated.',
    adjustBtn: 'Apply',
    adjustBalance: '± Balance',
    transactionTitle: 'Supplier Transactions',
    transAllSuppliers: 'All Suppliers',
    transTableSupplier: 'Supplier',
    transTableDesc: 'Description',
    transTableAmount: 'Amount',
    transTableOldBalance: 'Old Balance',
    transTableNewBalance: 'New Balance',
    transTableDate: 'Date',
    transEmpty: 'No records.',
    saved: 'Saved.',
    deleted: 'Deleted.',
    balanceUpdated: 'Balance updated.',
    adjustFailed: 'Error.',
    newTitle: 'New Supplier',
    currentBalance: 'Current',
    adjustApply: 'Apply',
    transactionsTitle: 'Supplier Transactions',
    allSuppliers: 'All Suppliers',
    colDescription: 'Description',
    colAmount: 'Amount',
    colOldBalance: 'Old Balance',
    colNewBalance: 'New Balance',
    colDate: 'Date',
  },

  common: {
    page: 'Page {current} / {last}',
    searchDots: 'Search…',
    selectDots: 'Select…',
  },
}
